import { useFlag } from '@listening/frontend/analytics/client';
import { FUNNEL_CAMPAIGN } from '@/components/funnel/config/funnels';
import { SqueezePage } from '@/components/funnel/squeeze/squeeze-page';
import { DefaultLandingPage } from './default-landing-page';

/**
 * The two arms of `academic-landing-funnel-v1`, rendered on `/academic` and
 * `/fb/academic`.
 *
 * Variant assignment arrives from the CloudFront viewer-request function via
 * `x-variants` (or the SSR-lambda fallback on PR previews), so `useFlag`
 * returns the assigned arm during SSR — the first paint is already correct
 * and there is no hydration flip. See `docs/guidelines/web/edge-bucketed-experiments.md`.
 *
 * Session replay is NOT started here even though `treatment` leads into the
 * replay-recorded funnel. Recording only one arm's landing page would put
 * that arm's bounce rate under a load the other never carries.
 */
export function AcademicLandingPage() {
  const { value: variant } = useFlag('academicLandingFunnelV1');

  return variant === 'treatment' ? (
    <SqueezePage campaign={FUNNEL_CAMPAIGN} />
  ) : (
    <DefaultLandingPage />
  );
}
